import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { IInjectable, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipOfferingsCreateControllerModule } from './controllers/MembershipOfferingsCreateController';

function TenantConfigListResolver(): IInjectable {
  return [
    'ApiService',
    function (ApiService: ApiService) {
      return ApiService.tenant.config.list();
    },
  ];
}

export const MembershipOfferingsCreateView = angular
  .module('acme.view.application.membership.offerings.create', [
    uiRouter,
    'ui.bootstrap',
    MembershipOfferingsCreateControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.offerings.create',
      url: '/create',
      views: {
        'subview-main@application': {
          controller: 'MembershipOfferingsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/offerings/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Membership Offering',
        permissions: ['MEMBERSHIP_OFFERING_CREATE'],
      },
      resolve: {
        TenantData: TenantConfigListResolver(),
      },
    });

    $stateProvider.state({
      name: 'application.membership.offerings.edit',
      url: '/:offeringId/edit',
      views: {
        'subview-main@application': {
          controller: 'MembershipOfferingsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/offerings/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Update Membership Offering',
        permissions: ['MEMBERSHIP_OFFERING_UPDATE'],
      },
      resolve: {
        TenantData: TenantConfigListResolver(),
      },
    });
  }).name;
